import { render } from "./fifteenPage.vue?vue&type=template&id=bea91ade&scoped=true"
import script from "./fifteenPage.vue?vue&type=script&lang=js"
export * from "./fifteenPage.vue?vue&type=script&lang=js"

import "./fifteenPage.vue?vue&type=style&index=0&id=bea91ade&lang=less&scoped=true"

import exportComponent from "/home/jenkins_home/workspace/c1-02_dwart2.0-apkpc-site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bea91ade"]])

export default __exports__